import angular from 'angular';
import { attSlideshowComponent } from './attSlideshowComponent';
import 'components/sharpr/image/sizer/imageSizerModule';
import 'components/sharpr/att/service/attServiceModule';
import 'components/sharpr/api/apiModule';

angular
	.module('sh.attSlideshow', ['sh.imageSizer', 'sh.attService', 'sh.api'])
	.component('shAttSlideshow', attSlideshowComponent());
